export default __webpack_public_path__ + "media/images/react_icons/mini-arrow-right-d1bdf22d13e28c8fcba0cb9f4b58c53a.svg";